export function AuthProviderSkeleton() {
  return (
    <div className="flex flex-wrap gap-3 justify-center">
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className="flex items-center justify-center w-12 h-12 bg-gray-200 rounded-lg animate-pulse"
        >
          {/* Icon placeholder */}
          <div className="w-6 h-6 bg-gray-300 rounded animate-pulse" />
        </div>
      ))}
    </div>
  );
}

export function AuthProviderSkeletonCompact() {
  return (
    <div className="flex flex-wrap gap-3 justify-center">
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className="flex items-center justify-center w-10 h-10 bg-gray-200 rounded-md animate-pulse"
        >
          <div className="w-5 h-5 bg-gray-300 rounded animate-pulse" />
        </div>
      ))}
    </div>
  );
}
